import * as React from 'react';
import {BreadcrumbItemProps} from './types';

export default class BreadcrumbItem extends React.Component<BreadcrumbItemProps, {}> {
  public render() {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/Breadcrumb/BreadcrumbItem.tsx